import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import 'bootstrap/dist/css/bootstrap.min.css'; 


import HomeHeader from "../header/HomeHeader";
import FooterMainView from "../footer/FooterMainView";
import ContactView from "../ContactView";
import PageTitle from "../common/PageTitle";
import EventCenterView from "./EventCenterView";
import New_helmet from "../New_helmet"; 

import event_main_img from "../images/event/event.jpg";   
import signUp_img from "../images/event/signUp.png"; 
import DeviceUtils from "../../../helper/DeviceUtils";
import styled from "styled-components";

const SecTitle=  styled.div`  
color:white;
position: relative;
  margin: 74px 0px 10px calc((100% - 490px) * 0);
  left: ${props => props.left}px;
  grid-area: 1 / 1 / 2 / 2;
  justify-self: start;
  align-self: start;
  font-size: ${props => props.fontSize}px;
  line-height: normal;
  letter-spacing: normal;
  `;
const EventTitle = ({index,title }) => { 

    return <div>
        <span className="pr-2">
            {index}.
        </span>
        <span>
            {title}
        </span>
    
    </div>
    };

const EventTitleHold = ({index,title,content }) => {  
        return <div>
            <EventTitle index={index} title={title}/>
            {content}
            <br/> 
        </div>
};
const EventLeftPaggind = ({index,title,content }) => {  
        return <div className="pl-4"> 
            {content}
            <br/> 
        </div>
};

const EventSte = ({title,connect }) => { 

        return <div> 
                {title} 
                <br/>
            <span>
                {connect}
            </span> 
                <br/>
                <br/>
        </div>
        };
        
 

class EventPage extends Component {
 
    constructor(props) {
        super(props);
        this.state = {
            SteArray:[
                {
                    title:"Festival Director |",
                    connect:"Yvon Liu"
                },
                {
                    title:"Festival Coordinator |",
                    connect:"James Shih 、Luna Huang"
                },
                {
                    title:"Designers |",
                    connect:"James Shih、 Luna Huang"
                },
                {
                    title:"Festival Writers |",
                    connect:"James Shih、 Yu Yen Tsai"
                },
                {
                    title:"Video Editors |",
                    connect:"James Shih、 Luna Huang"
                }
            
            ],

            no4Array:[ 
                "All submitted films should be no longer than 15 mins, including opening and ending credits.",

                "Please upload your film to Google Drive and send the link to us (minimum resolution: 1080p)",

                "Please upload a film poster (size: 68.6x101.4 cm)",

                "Please include a paragraph of film introduction and a full staff list",

                "Please provide the following information: film length, language, shooting locations, and completion date.",

                "Submission with scripts is preferable",
            ],

            
            no8Array:[ 
                "The Festival may be canceled or rescheduled due to weather conditions or other unforeseen circumstances.", 
                "Apart from elements provided by the Festival, submission must be your personal work. In case of breaching this rule, submission will be disqualified.",
 
                "Copying is strictly forbidden. Images, articles, and films submitted without copyrights or portrait rights obtained are prohibited. In case of infringement of copyrights, patent rights, and other rights after being reported, participants shall bear all legal responsibilities, and any award given will be dis-qualified.",
 
                "Submission must not include content that violates public order and morality.",
 
                "The Festival reserves the right to show your film at the times, dates and locations of our choos-ing with no limit of screening times.",
 
                "By submitting, the Festival will utilize any personal data and details that you submit to us.",
 
                "Submission to the Festival constitutes agreement to all rules, regulations, and conditions.",
 
            ]
        };
    }

    async componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

    }
    render() { 

        return (
            <div id={"EventPage"} className="overflow-hidden"  style={{backgroundColor: '#000000'}} >
                <New_helmet />

                <HomeHeader/>

                <FadeIn>
                    
                    <PageTitle title="" /> 
                    
                    

                    <EventCenterView
                    image={event_main_img}
                    title={"2021 Salon Film Festival"}
                    rightContent={<div>

 
                        <EventTitleHold index='1' title="ABOUT US" 
                            content={
                                <div>
                                    Our team focuses on subtitle localization, and always hopes to bring good films to audiences around the world. With enthusiasm, we are determined to establish an "Independent Film Salon" in 2021.
                                    <br/>
                                    The Salon Film Festival aims to share films from different cultures with our global audiences. We believe more passionate filmmakers can be connected through this amazing event. 
                                </div> 
                            }/>
                         
                        {this.state.SteArray.map((obj,index)=>{ 
                            return <div key={index}>
                                <EventSte title={obj['title']} connect={obj['connect']} />
                            </div>;
                        })}

 
                        <EventTitleHold index='2' title="Eligibility" 
                            content={
                                <div>
                                Everyone engaged in filmmaking and would like to show his/her work to the international audience is welcomed to participate individually or as a group. The Salon Film Festival accepts any possi-bilities and cultural backgrounds. We respect all creators and fully value the originality and visual impacts.
                                <br/>
                            </div> 
                        }/>

                        <EventTitleHold index='3' title="Registration" 
                            content={
                                <div>
                                Please submit your application via SubPro Studio’s Facebook page. You will need to fill the form choose your category, and upload your work.
                                <br/>
                            </div> 
                        }/>
                        
                        <EventTitleHold index='4' title="Formats" 
                            content={
                                <EventLeftPaggind content={
                                    <div>
                                         {this.state.no4Array.map((obj,index)=>{ 
                                            return <div key={index}>
                                                <EventTitle index={`4.${(index+1)}`}  title={obj}   />
                                            </div>;
                                        })} 
                                </div>} /> 
                            }/>


                        <EventTitleHold index='5' title="Timeline" 
                            content={
                                <div> 
                                Entries Open: October 30<br/>
                                Submission Deadline: December 10<br/>
                                Nomination Announced: December 17<br/>
                                Film Festival: 2022 January 7<br/>
                            </div> 
                        }/>

                        <EventTitleHold index='6' title="Awards" 
                            content={
                                <div> 
                                The Salon Festival features 3 film categories: <br/> 
                                
Independent Short film / Documentary Short Film / Video Art. <br/>

5 films will be nominated in every section, and 1 film in each will be awarded. <br/>

No filming style and method are limited. <br/>

Along with the award certificate, awarded films will be screened during the Festival.<br/>
                            </div> 
                        }/>

                        <EventTitleHold index='7' title="Organizers" 
                                                    content={
                                                        <div> 
                                                        SubPro Studio
                                                    </div> 
                                                }/>

                                                
                        
                        <EventTitleHold index='8' title="Rules & Terms" 
                            content={
                                <EventLeftPaggind content={
                                    <div>
                                         {this.state.no8Array.map((obj,index)=>{ 
                                            return <div key={index}>
                                                <EventTitle index={`8.${(index+1)}`}  title={obj}   />
                                            </div>;
                                        })} 
                                </div>} /> 
                            }/>
                    </div>}
                    
                    Name="Luna Huang"
                    buttons={<div>
                        <button
                            className="mt-5 py-2 px-3 mr-3 mainYellowBg border border-white"
                            ><b>Watch Now</b></button>  
                    </div>}
                />

                
                     
                    <div style={{ 
                                paddingLeft:`${DeviceUtils.isMobile()===true?0:160}px`
                        }}>
                            
                        <SecTitle 
                            fontSize={(DeviceUtils.isMobile()===true)?24:34}
                            left={(DeviceUtils.isMobile()===true)?28:119}
                            className="newpageP_b">
                                <b>{"Let’s Work Together"}</b>
                                <br/>
                            <smal style={{fontSize:`${(DeviceUtils.isMobile()===true)?12:12}pt`}}>Get in touch so we can start working together.</smal>
                        </SecTitle> 
                    </div> 
                    <div style={{ 
                                paddingLeft:`${DeviceUtils.isMobile()===true?0:90}px`
                        }}> 
                        <ContactView  type="EventPage"/>
                    </div> 
                        
                    <FooterMainView />
                </FadeIn>
            </div>
        );

    }
}


EventPage.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {   })(
    withRouter(EventPage)
);



// WEBPACK FOOTER //
// ./src/components/homepage_new/event/EventPage.js